<template>
  <div>
    <a-modal title="配置型号" style="top: 20px;" :width="1000" v-model="show" @ok="handleOk">
      <a-form :form="form2">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号" style="width:410px;">
              <a-input-search style="margin-bottom: 8px" @search="onSearch" v-model="searchValue" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-tree :disabled="disabled" checkable @expand="onExpand" :expandedKeys="expandedKeys"
        :auto-expand-parent="autoExpandParent" v-model="checkedKeys" :treeData="treeData" />
    </a-modal>
  </div>
</template>

<script>
import {
  selectenterprise2
} from '@/api/accessory/accessory'
export default {
  props: ['modelIds', 'disabled'],
  data() {
    return {
      show: false,
      treeData: [],
      searchValue: '',
      expandedKeys: [], // 展开项的key集合
      checkedKeys: [], // 选中的key
      autoExpandParent: true
    }
  },
  watch: {
    checkedKeys(val) {
      console.log('onCheck', val);
    },
  },
  mounted() {
  },
  methods: {
    //配置
    init() {
      this.show = true
      this.searchValue = ''
      selectenterprise2().then(res => {
        // [{ key: "SMART_SWITCH",
        // title: "智能锁",
        // children:[{
        //   key: "111",
        //   title: "智能锁1",
        // }]} ]
        this.treeData = res.rows
        if (this.modelIds.length) {
          this.expandedKeys = this.modelIds
          this.checkedKeys = this.modelIds
        } else {
          this.expandedKeys = ['SMART_SWITCH']
          this.checkedKeys = []
        }
      })
    },
    onExpand(expandedKeys) {
      console.log(111, expandedKeys)
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSearch(e) {
      let candidateKeysList = this.getkeyList(this.searchValue, this.treeData, [])
      console.log(1111111, candidateKeysList)
      // this.checkedKeys = this.checkedKeys.concat(candidateKeysList) // 搜索匹配到的选中
      this.expandedKeys = candidateKeysList; // 搜索匹配到的展开
    },
    //获取节点中含有value的所有key集合
    getkeyList(value, tree, keyList) {
      //遍历所有同一级的树
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i]
        //如果该节点存在value值则push
        if (node.title.indexOf(value) > -1) {
          keyList.push(node.key)
        }
        //如果拥有孩子继续遍历
        if (node.children) {
          this.getkeyList(value, node.children, keyList)
        }
      }
      //因为是引用类型，所有每次递归操作的都是同一个数组
      return keyList
    },
    handleOk() {
      this.$emit('ok', this.checkedKeys)
      this.show = false
    },

  },
}
</script>
<style lang='scss' scoped>

</style>